import { HTMLAttributes } from 'react';

import { ContextMenuLabel } from '../../primitives/context-menu';
import { cn } from '../../utils/cn';

interface ContextMenuLabelClampProp extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  clamp?: number;
  text: string;
}

/**
 * Set `className="w-full"` If the wrapper has an static width
 * to fit the parent container.
 */
export function ContextMenuLabelClamp({ clamp = 3, className, text }: ContextMenuLabelClampProp) {
  const lineClamp = `line-clamp-${clamp.toString()}`;

  return (
    <ContextMenuLabel>
      <div className={cn('w-[7.5rem] p-0 break-words text-muted-foreground', lineClamp, className)}>
        {text}
      </div>
    </ContextMenuLabel>
  );
}
